import { HugeiconsIcon } from "@hugeicons/react"
import { Refresh01Icon } from "@hugeicons/core-free-icons"
import { Button } from "@/components/ui/button"

export function MonitoringErrorFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="max-w-md text-center">
        <h1 className="text-xl font-semibold tracking-tight">
          Произошла ошибка интерфейса
        </h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Мы уже знаем о ней.
        </p>
        <Button
          type="button"
          className="mt-6"
          onClick={() => window.location.reload()}
        >
          <HugeiconsIcon icon={Refresh01Icon} strokeWidth={2} data-icon="inline-start" />
          Перезагрузить
        </Button>
      </div>
    </div>
  )
}
